<template>
  <div class="image-set">
    <div class="image-set__left">
      <ContentfulImage
        class="image-set__image"
        :entry="content.fields?.image1 || content.image1"
        :width="mq.xsmall || mq.small ? 425 : 320"
        :height="mq.xsmall || mq.small ? 240 : 360"
        fit="fill"
        :use-light-box="true"
      />
    </div>
    <div class="image-set__right">
      <ContentfulImage
        class="image-set__image"
        :entry="content.fields?.image2 || content.image2"
        :width="mq.xsmall || mq.small ? 425 : 305"
        :height="mq.xsmall || mq.small ? 240 : 172"
        fit="fill"
        :use-light-box="true"
      />
      <ContentfulImage
        class="image-set__image"
        :entry="content.fields?.image3 || content.image3"
        :width="mq.xsmall || mq.small ? 425 : 305"
        :height="mq.xsmall || mq.small ? 240 : 172"
        fit="fill"
        :use-light-box="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  content?: Record<string, any>;
};
const { mq } = useMediaQueries();
const { content } = withDefaults(defineProps<Props>(), {
  content: () => {},
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'ImageSetOfThree',
});
</script>

<style lang="scss">
.image-set {
  display: flex;
  flex-direction: column;

  @screen md {
    flex-flow: row wrap;
    justify-content: space-between;
    @apply mt-5;
  }

  &__image {
    border-radius: 4px;
    @apply mb-4;

    @screen md {
      margin-bottom: 0;
    }
  }

  &__right {
    @screen md {
      display: flex;
      flex-flow: column wrap;
      justify-content: space-between;
    }
  }
}
</style>
